import { render, staticRenderFns } from "./declarations.vue?vue&type=template&id=b295d08a&scoped=true"
import script from "./declarations.vue?vue&type=script&lang=js"
export * from "./declarations.vue?vue&type=script&lang=js"
import style0 from "./declarations.vue?vue&type=style&index=0&id=b295d08a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b295d08a",
  null
  
)

export default component.exports